import { network_errors } from "./AppState"

const GMS = window.gms
const VC = GMS.VertxClient

class SGMSApi {
  constructor() {
    this.client = null
    this.isAnonymous = false
    this.currentUser = null

    this.analyticsApi = new GMS.module.analytics.AnalyticsApi()

    this.testWSConnection()
  }

  testWSConnection() {

    /* tests de connexion */
    var apiKey = 'oCdCMcMPQpbvNjUIzqtvF1d2X2okWpDQj4AwARJuAgtjhzKxVEjQU6IdCjwm';
    var channelId = 1;
    var piesocket = new WebSocket(`wss://demo.piesocket.com/v3/${channelId}?api_key=${apiKey}&notify_self`);

    piesocket.onopen = () => {
      piesocket.send("connection_test")
    }
    // au bout de 3 secondes, on ajoute une alerte si on n'a tjs pas reçu le message
    piesocket.onmessage = function(message) {
      if(message.data === "connection_test") {
        piesocket.close()
      }
    }

    piesocket.onerror = (error) => {
      network_errors.set(["Error on websocket connection test"])
      piesocket.close()
    }
  }

  init(ip, port) {
    this.client = VC.CreateVertxClient(ip, port);
    this.client.SIG_SocketConnection.Add( (success, message)=> {
      console.log("message", message)
      if(!success) { network_errors.set(["Error while connecting to server"]) }
      else { network_errors.set([]) }

    })
    this.analyticsApi.init(this.client)

  }

  anonymousConnect(universe, app, localStorageUserKey) {
    return new Promise( (resolve, reject) => {
      this.client.UserAnonymousAdd(universe, (success, msg, data) => {
        if (success) {
          try{
            this.login(universe, app, data.UserLogin, data.UserPassword)
            .then(() => {

              let token = this.client.getSessionToken()
              localStorage.setItem(localStorageUserKey, token)
              this.isAnonymous = true
              resolve(data)
            })

          } catch(err) {
            console.log(err)
          }
        } else {
          reject(msg)
        }
      })
    })
  }

  login(universe, app, login, password) {
    return new Promise( (resolve, reject) => {
      this.client.UserConnect(universe, app, login, password, (success, msg, data) => {
        if(success) {

          this.getUserId().then(id => {
            this.currentUser = data
            this.currentUser._id = id
            this.isAnonymous = false

            let cd = VC.GetJsonObject(data)
            if(Object.keys(cd).length > 0) this.userCustomDatas = cd


            resolve()
          }).catch(() => reject("getUserId " + msg))
        }
        else {
          console.log("UserConnect", msg)
          reject(msg)
        }
      })
    })
  }

  getUserId() {
    return new Promise( (resolve, reject) => {
      this.client.UserGetInfo((res, msg, data) => {
        if (res) {
          let userData = JSON.parse(data.DataArray);
          resolve(userData._id)
        } else {
          reject(msg)
        }
      })
    })
  }



  sendNavigationEvent(id, value) {
    if(value === "ENTER") this.analyticsApi.navigationEnter(id)
    if(value === "LEAVE") this.analyticsApi.navigationLeave(id)
  }
  sendActionEvent(e, id) {
    const x = e && e.clientX ? e.clientX : null
    const y = e && e.clientY ? e.clientY : null
    this.analyticsApi.action(id, x, y)
  }


  sendContentEvent(id, value) {
    if(value === "SHOW") this.analyticsApi.contentShow(id)
    if(value === "HIDE") this.analyticsApi.contentHide(id)
    if(value === "INTERRUPTED") this.analyticsApi.contentInterrupted(id)
  }
  sendEvent(data) {
    this.analyticsApi.send(data)
 }


}


export default new SGMSApi()
